module.exports = __webpack_public_path__ + "img/肌如初雪套装_05.b5d87177.jpg";